import { render, staticRenderFns } from "./StudentUploadDocument.vue?vue&type=template&id=6e04c33f&"
import script from "./StudentUploadDocument.vue?vue&type=script&lang=ts&"
export * from "./StudentUploadDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports